import { ThunkAction } from "redux-thunk";
import { Action } from "redux";

import { RootState } from "app/redux/reducer";
import { ArtistRoleService } from "./service";
import { showMessage, toggleConfirmDialog, toggleLoader } from "app/redux/system/actions";
import { initialPageData } from "app/redux/page/actions";
import { MessageType } from "app/redux/system/types";
import { IArtistRole } from "./types";
import { HttpStatusCode, IList, IListFilter } from "app/shared";
import { mapArtistRoleFromEntity, mapArtistRoleFromModel } from "./mapping";

type ThunkResult<R> = ThunkAction<R, RootState, {}, Action>;

export function getArtistRole(id: string, language?: string, notFill?: boolean): ThunkResult<Promise<any>> {
    return async (dispatch, getState) => {
        const service = new ArtistRoleService();
        dispatch(toggleLoader());
        const response = await service.getArtistRole(id, language || getState().system.defaultLanguage);
        dispatch(toggleLoader());

        if (response.status === HttpStatusCode.OK) {
            const mapped = mapArtistRoleFromEntity(response.data.attributes["artistRole"] || {});

            if (!notFill) {
                dispatch(initialPageData<IArtistRole>(mapped));
            }

            return mapped;
        }
        dispatch(showMessage("Bir hata oluştu. Servis sağlayıcınızla iletişime geçin ya da daha sonra tekrar deneyiniz!", "Bir Hata Oluştu!", MessageType.ERROR))
        return false;
    };
}

export function getArtistRoleByLanguage(pageData: IArtistRole, language: string, isOverride?: boolean): ThunkResult<Promise<any>> {
    return async (dispatch, getState) => {
        const service = new ArtistRoleService();
        dispatch(toggleLoader());
        const response = await service.getArtistRole(pageData.id as string, isOverride ? getState().system.defaultLanguage : language);
        if (response.status === HttpStatusCode.OK) {
            const mapped = mapArtistRoleFromEntity(response.data.attributes["artistRole"] || {});
            const data = { ...mapped, language: language, id: isOverride ? pageData.id : mapped.id };
            dispatch(initialPageData<IArtistRole>(data));
            if (isOverride) {
                dispatch(updateArtistRole(data));
            }
            dispatch(toggleLoader());
            return true;
        }
        else {
            dispatch(toggleConfirmDialog(true, {
                title: "Uyarı!",
                text: `Geçerli dil'e (${language}) ait bir kayıt bulunamadı. Varsayılan dil üzerinden seçtiğiniz dile göre kayıt oluşturulsun mu?`,
                button: {
                    approveText: "Varsayılan Dil'den Oluştur"
                },
                callback: () => {
                    dispatch(createArtistRole({ ...pageData, id: "", title: `${pageData.title} (${language.toUpperCase()})`, language })).then(res => {
                        if (res) {
                            dispatch(getArtistRole(res.id as string, language));
                        }
                    });
                    return true;
                }
            }))
        }
        dispatch(toggleLoader());
        return false;
    };
}


export function getArtistRoles(options: IListFilter): ThunkResult<Promise<boolean>> {
    return async (dispatch) => {
        const service = new ArtistRoleService();
        dispatch(toggleLoader());
        const response = await service.getArtistRoles(options);
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            const mapped = (response?.data?.attributes?.list || []).map((item) =>
                mapArtistRoleFromEntity(item)
            );
            dispatch(initialPageData<IList<IArtistRole[]>>({
                list: mapped,
                pageSize: response.data.attributes.pageSize,
                totalCount: response.data.attributes.total,
                pageCount: Math.ceil(response.data.attributes.total / response.data.attributes.pageSize)
            }));
            return true;
        }
        return false;
    };
}

export function getArtistRolesForLocal(language: string): ThunkResult<Promise<IArtistRole[]>> {
    return async () => {
        const service = new ArtistRoleService();
        const response = await service.getArtistRoles({ page: 1, pageSize: 100, descending: false, language });
        if (response.status === HttpStatusCode.OK) {
            const mapped = (response?.data?.attributes?.list || []).map((item) =>
                mapArtistRoleFromEntity(item)
            );
            return mapped;
        }
        return [];
    };
}

export function createArtistRole(request: IArtistRole): ThunkResult<Promise<IArtistRole | null>> {
    return async (dispatch) => {
        const service = new ArtistRoleService();
        dispatch(toggleLoader());
        const response = await service.createArtistRole(mapArtistRoleFromModel(request));
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            return mapArtistRoleFromEntity(response.data.attributes["artistRole"] || {});
        }
        return null;
    };
}

export function updateArtistRole(request: IArtistRole): ThunkResult<Promise<boolean>> {
    return async (dispatch) => {
        const service = new ArtistRoleService();
        dispatch(toggleLoader());
        const response = await service.updateArtistRole(mapArtistRoleFromModel(request));
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            return true;
        }
        return false;
    };
}

export function deleteArtistRole(id: string): ThunkResult<Promise<boolean>> {
    return async (dispatch) => {
        const service = new ArtistRoleService();
        dispatch(toggleLoader());
        const response = await service.deleteArtistRole(id);
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            return true;
        }
        dispatch(showMessage("Bir hata oluştu. Servis sağlayıcınızla iletişime geçin ya da daha sonra tekrar deneyiniz!", "Bir Hata Oluştu!", MessageType.ERROR))
        return false;
    };
}